import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, Flex, Image } from "@chakra-ui/react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ResponsiveModal from "../common/ResponsiveModal";
import { IMG_URL } from "../common/Constant";
const WhatsHappeningCardDetailsBottomSheet = ({ isOpen, onClose, happening }) => {
    const navigate = useNavigate();
    const formatDateTime = (startTime, endTime) => {
        if (!startTime)
            return "";
        const startDate = new Date(startTime);
        const endDate = endTime ? new Date(endTime) : null;
        if (!endDate || startDate.toDateString() === endDate.toDateString()) {
            // Single day format: "SAT, 01 Aug | 10:00 AM – 12:00 PM"
            const dayOfWeek = startDate
                .toLocaleDateString("en-US", { weekday: "short" })
                .toUpperCase();
            const day = startDate.toLocaleDateString("en-US", { day: "2-digit" });
            const month = startDate.toLocaleDateString("en-US", { month: "short" });
            const startTimeFormatted = startDate
                .toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            })
                .toUpperCase();
            const endTimeFormatted = endDate
                ? endDate
                    .toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                })
                    .toUpperCase()
                : startTimeFormatted;
            return `${dayOfWeek}, ${day} ${month} | ${startTimeFormatted} – ${endTimeFormatted}`;
        }
        else {
            // Multi-day format: "Sep 12, 3:00 PM – Sep 14, 11:00 AM"
            const startFormatted = startDate.toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
            }) +
                ", " +
                startDate.toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                });
            const endFormatted = endDate.toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
            }) +
                ", " +
                endDate.toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                });
            return `${startFormatted} – ${endFormatted}`;
        }
    };
    const handleParticipantClick = (participant) => {
        // Close the modal first to prevent URL manipulation interference
        onClose();
        // Small delay to ensure modal is closed before navigation
        setTimeout(() => {
            if (participant.type === "VENUE" && participant.id) {
                navigate(`/pub/detail/${participant.id}`, { replace: true });
            }
            else if (participant.type === "PARTNER" && participant.uuid) {
                navigate(`/partner/view/${participant.uuid}`, { replace: true });
            }
        }, 100);
    };
    const handlePartnerClick = (partner) => {
        // Close the modal first to prevent URL manipulation interference
        onClose();
        // Small delay to ensure modal is closed before navigation
        setTimeout(() => {
            if (partner.type === "VENUE" && partner.id) {
                navigate(`/pub/detail/${partner.id}`, { replace: true });
            }
            else if (partner.type === "PARTNER" && partner.uuid) {
                navigate(`/partner/view/${partner.uuid}`, { replace: true });
            }
        }, 100);
    };
    const getParticipantCategory = (type) => {
        switch (type) {
            case "VENUE":
                return "Venue";
            case "PARTNER":
                return "Partner";
            case "USER":
                return "User";
            default:
                return type;
        }
    };
    return (_jsx(ResponsiveModal, { isOpen: isOpen, onClose: onClose, header: "What's Happening", showCloseButton: true, bg: "#111111", color: "white", size: "lg", children: _jsxs(Box, { px: 6, py: 8, overflowY: "auto", maxH: "70vh", children: [_jsxs(Box, { w: "100%", bg: "#1A1A1A", borderRadius: "12px", border: "1px solid #2A2A2A", p: 6, mb: 6, children: [_jsx(Text, { fontSize: "16px", fontWeight: "600", color: "white", mb: 2, noOfLines: 2, lineHeight: "1.3", children: happening.title }), happening.description && (_jsx(Text, { fontSize: "12px", color: "white", mb: 2, noOfLines: 3, lineHeight: "1.4", children: happening.description })), (happening.startTime ||
                            happening.start_time ||
                            happening.endTime ||
                            happening.end_time) && (_jsxs(Flex, { alignItems: "center", mb: 3, children: [_jsx(Image, { src: `${IMG_URL}/icons/mdi_calendar.png`, alt: "Calendar", w: "16px", h: "16px", mr: 2 }), _jsx(Text, { fontSize: "12px", color: "#A0A0A0", fontWeight: "500", children: formatDateTime(happening.startTime || happening.start_time, happening.endTime || happening.end_time) })] }))] }), happening.partners && happening.partners.length > 0 && (_jsxs(Box, { bg: "#1A1A1A", borderRadius: "12px", border: "1px solid #2A2A2A", p: 6, mb: 6, children: [_jsx(Text, { fontSize: "18px", fontWeight: "bold", color: "white", mb: 4, children: "Partners" }), happening.partners.map((partner, index) => {
                            var _a;
                            return (_jsxs(Box, { children: [_jsxs(Flex, { alignItems: "center", py: 4, children: [_jsx(Box, { w: "50px", h: "50px", borderRadius: "full", overflow: "hidden", bg: "#2A2A2A", display: "flex", alignItems: "center", justifyContent: "center", mr: 4, children: partner.imageUrl ? (_jsx(Image, { src: partner.imageUrl, alt: partner.name, w: "100%", h: "100%", objectFit: "cover" })) : (_jsx(Text, { fontSize: "18px", color: "white", fontWeight: "bold", children: partner.name.charAt(0).toUpperCase() })) }), _jsxs(Box, { flex: "1", children: [_jsx(Text, { fontSize: "16px", fontWeight: "bold", color: "white", mb: 1, children: partner.name.toUpperCase() }), _jsx(Text, { fontSize: "12px", color: "#A0A0A0", children: getParticipantCategory(partner.type) }), partner.shortAddress && (_jsx(Text, { fontSize: "10px", color: "#808080", mt: 1, children: partner.shortAddress }))] }), _jsx(Flex, { gap: 2, children: _jsx(Box, { as: "button", p: 2, borderRadius: "md", border: "1px solid #A0A0A0", color: "white", cursor: "pointer", _hover: { bg: "#2A2A2A" }, onClick: () => handlePartnerClick(partner), children: _jsx(FaExternalLinkAlt, {}) }) })] }), index < (((_a = happening.partners) === null || _a === void 0 ? void 0 : _a.length) || 0) - 1 && (_jsx(Box, { height: "1px", bg: "#2A2A2A", my: 2 }))] }, partner.id));
                        })] })), happening.participants && happening.participants.length > 0 && (_jsxs(Box, { bg: "#1A1A1A", borderRadius: "12px", border: "1px solid #2A2A2A", p: 6, children: [_jsx(Text, { fontSize: "18px", fontWeight: "bold", color: "white", mb: 4, children: "Participants" }), happening.participants.map((participant, index) => {
                            var _a;
                            return (_jsxs(Box, { children: [_jsxs(Flex, { alignItems: "center", py: 4, children: [_jsx(Box, { w: "50px", h: "50px", borderRadius: "full", overflow: "hidden", bg: "#2A2A2A", display: "flex", alignItems: "center", justifyContent: "center", mr: 4, children: participant.imageUrl ? (_jsx(Image, { src: participant.imageUrl, alt: participant.name, w: "100%", h: "100%", objectFit: "cover" })) : (_jsx(Text, { fontSize: "18px", color: "white", fontWeight: "bold", children: participant.name.charAt(0).toUpperCase() })) }), _jsxs(Box, { flex: "1", children: [_jsx(Text, { fontSize: "16px", fontWeight: "bold", color: "white", mb: 1, children: participant.name.toUpperCase() }), _jsx(Text, { fontSize: "12px", color: "#A0A0A0", children: getParticipantCategory(participant.type) })] }), _jsx(Flex, { gap: 2, children: _jsx(Box, { as: "button", p: 2, borderRadius: "md", border: "1px solid #A0A0A0", color: "white", cursor: "pointer", _hover: { bg: "#2A2A2A" }, onClick: () => handleParticipantClick(participant), children: _jsx(FaExternalLinkAlt, {}) }) })] }), index < (((_a = happening.participants) === null || _a === void 0 ? void 0 : _a.length) || 0) - 1 && (_jsx(Box, { height: "1px", bg: "#2A2A2A", my: 2 }))] }, participant.id));
                        })] }))] }) }));
};
export default WhatsHappeningCardDetailsBottomSheet;
